module.exports = __webpack_public_path__ + "static/media/IMG_5089.eca29aaa.JPG";